import { defineStore } from "pinia";

import { index } from "src/api/communication-settings";

const getInitialState = () => {
  return {
    communications: [],
  };
};

export const useCommunicationSettingsStore = defineStore(
  "communication-settings",
  () => {
    let state = reactive(getInitialState());

    const getCommunicationSettings = async (options = {}) => {
      // get and create communication type of the user
      try {
        const response = await index(options);

        state.communications = response;

        return response;
      } catch (error) {
        console.error("Failed to fetch communication types:", error);

        throw error;
      }
    };

    const reset = () => {
      Object.assign(state, getInitialState());
    };

    return {
      ...toRefs(state),

      getCommunicationSettings,

      reset,
    };
  },
);

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useCommunicationSettingsStore, import.meta.hot),
  );
}
